import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectSelectedIncompleteSprayEventsUuids } from '../SprayEventsVirtualizedTable/selectors';

const selectHasIncompleteSprayEvents = createDeepEqualSelector(
    makeSelectSelectedIncompleteSprayEventsUuids(),
    (incompleteSprayEvents) =>
        Boolean(incompleteSprayEvents && incompleteSprayEvents.length)
);

const makeSelectHasIncompleteSprayEvents = (): typeof selectHasIncompleteSprayEvents =>
    selectHasIncompleteSprayEvents;

export { makeSelectHasIncompleteSprayEvents };
